<template>
  <el-card v-loading="loading" shadow="never">
    <div slot="header">
      <span>Operations Information</span>
    </div>
    <el-form
      :model="form"
      label-position="left"
      ref="opsInfoForm"
      label-width="200px"
    >
      <!-- WiFi Details Section -->
      <el-divider content-position="left">WiFi Details</el-divider>
      <el-form-item label="WiFi Name (SSID)" prop="wifiDetails.ssid">
        <el-input
          v-model="form.wifiDetails.ssid"
          placeholder="Enter WiFi network name"
        ></el-input>
      </el-form-item>
      <el-form-item label="WiFi Password" prop="wifiDetails.password">
        <el-input
          v-model="form.wifiDetails.password"
          type="password"
          placeholder="Enter WiFi password"
          show-password
        ></el-input>
      </el-form-item>

      <!-- Access & Security Section -->
      <el-divider content-position="left"
        >Essential Access & Security</el-divider
      >
      <el-form-item
        label="Common Area Door Code"
        prop="accessSecurity.commonAreaDoorCode"
      >
        <el-input
          v-model="form.accessSecurity.commonAreaDoorCode"
          placeholder="Code for access to common areas, warehouse, office transitions"
          type="password"
          show-password
        ></el-input>
      </el-form-item>
      <el-form-item label="Gate Code" prop="accessSecurity.gateCode">
        <el-input
          v-model="form.accessSecurity.gateCode"
          placeholder="Code for loading areas and perimeter gates"
          type="password"
          show-password
        ></el-input>
      </el-form-item>
      <el-form-item
        label="Conference Room Code"
        prop="accessSecurity.conferenceRoomCode"
      >
        <el-input
          v-model="form.accessSecurity.conferenceRoomCode"
          placeholder="Code for meeting space access"
          type="password"
          show-password
        ></el-input>
      </el-form-item>
      <el-form-item
        label="Package Area Code"
        prop="accessSecurity.packageAreaCode"
      >
        <el-input
          v-model="form.accessSecurity.packageAreaCode"
          placeholder="Code for access to package area"
          type="password"
          show-password
        ></el-input>
      </el-form-item>
      <el-form-item label="Mailroom Code" prop="accessSecurity.mailroomCode">
        <el-input
          v-model="form.accessSecurity.mailroomCode"
          placeholder="Code for access to mail facilities"
          type="password"
          show-password
        ></el-input>
      </el-form-item>

      <!-- Mail & Delivery Section -->
      <el-divider content-position="left"
        >Mail & Delivery Information</el-divider
      >
      <el-form-item
        label="Location Address for Receiving"
        prop="mailDelivery.receivingAddress"
      >
        <el-input
          v-model="form.mailDelivery.receivingAddress"
          type="textarea"
          :rows="4"
          placeholder="e.g.:
Member Business Name
2455 NW Nicolai Street, Suite B-MEMBER UNIT NUMBER
Portland, OR 97210"
        ></el-input>
      </el-form-item>

      <el-divider content-position="left"
        >Incoming Mail/Package Pickup Locations</el-divider
      >
      <el-form-item
        label="UPS, FedEx"
        prop="mailDelivery.incomingUpsFedexLocation"
      >
        <el-input
          v-model="form.mailDelivery.incomingUpsFedexLocation"
          placeholder="e.g., Near Dock 3, across from warehouse bathrooms"
        ></el-input>
      </el-form-item>
      <el-form-item label="USPS" prop="mailDelivery.incomingUspsLocation">
        <el-input
          v-model="form.mailDelivery.incomingUspsLocation"
          placeholder="e.g., Near Dock 3, across from warehouse bathrooms"
        ></el-input>
      </el-form-item>

      <el-divider content-position="left"
        >Outgoing Mail/Package Pickup Locations</el-divider
      >
      <el-form-item
        label="UPS, FedEx"
        prop="mailDelivery.outgoingUpsFedexLocation"
      >
        <el-input
          v-model="form.mailDelivery.outgoingUpsFedexLocation"
          placeholder="e.g., Near Dock 3, across from warehouse bathrooms"
        ></el-input>
      </el-form-item>
      <el-form-item label="USPS" prop="mailDelivery.outgoingUspsLocation">
        <el-input
          v-model="form.mailDelivery.outgoingUspsLocation"
          placeholder="e.g., Near Dock 3, across from warehouse bathrooms"
        ></el-input>
      </el-form-item>

      <el-divider content-position="left"
        >Outgoing Mail/Package Pickup Schedules</el-divider
      >
      <el-form-item label="UPS" prop="mailDelivery.upsSchedule">
        <el-input
          v-model="form.mailDelivery.upsSchedule"
          placeholder="e.g., Around 3p daily, Mon-Fri"
        ></el-input>
      </el-form-item>
      <el-form-item label="FedEx" prop="mailDelivery.fedexSchedule">
        <el-input
          v-model="form.mailDelivery.fedexSchedule"
          placeholder="e.g., Around 3p daily, Mon-Fri"
        ></el-input>
      </el-form-item>
      <el-form-item label="USPS" prop="mailDelivery.uspsSchedule">
        <el-input
          v-model="form.mailDelivery.uspsSchedule"
          placeholder="e.g., Around 3p daily, Mon-Sun"
        ></el-input>
      </el-form-item>

      <!-- Facility Guidelines Section -->
      <el-divider content-position="left">Facility Guidelines</el-divider>
      <el-form-item
        label="Trash/Recycling Location"
        prop="trashPickup.location"
      >
        <el-input
          v-model="form.trashPickup.location"
          placeholder="e.g., Near Dock 6, use code XXXX"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="Trash/Recycling Collection Schedule"
        prop="trashPickup.schedule"
      >
        <el-input
          v-model="form.trashPickup.schedule"
          placeholder="e.g., Mon, Weds & Fri by 6am"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="Facility Rules & Fines"
        prop="guidelines.rulesPdf.url"
      >
        <div
          style="display: flex; gap: 12px; align-items: center; flex-wrap: wrap;"
        >
          <el-button
            v-if="form.guidelines.rulesPdf.url"
            size="small"
            type="secondary"
            icon="el-icon-download"
            @click="viewRulesPdf"
          >
            Download PDF
          </el-button>
          <Upload
            pdf
            no-tip
            :thumbnail="false"
            :upload-prefix="`location/${facility}/`"
            @upload-completed="handleRulesPdfUploaded"
            :button-text="
              form.guidelines.rulesPdf.url ? 'Upload new PDF' : 'Upload PDF'
            "
          />
          <el-button
            v-if="form.guidelines.rulesPdf.url"
            size="small"
            type="danger"
            plain
            @click="deleteRulesPdf"
          >
            Delete PDF
          </el-button>
        </div>
      </el-form-item>
      <el-form-item
        label="Forklift Training"
        prop="guidelines.forkliftTrainingUrl"
      >
        <el-input
          v-model="form.guidelines.forkliftTrainingUrl"
          placeholder="URL to forklift training on RS website"
        >
          <template slot="prepend">URL</template>
        </el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="submitForm"
          >Save Operations Info</el-button
        >
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
import axios from 'axios';
import { ADMIN_API_BASE } from '../env';
import Upload from './Uploader';

export default {
  name: 'FacilityOpsInfoForm',
  components: { Upload },
  props: {
    facility: { type: String, required: true },
  },
  data() {
    return {
      loading: false,
      form: {
        wifiDetails: {
          ssid: '',
          password: '',
        },
        trashPickup: {
          location: '',
          schedule: '',
        },
        accessSecurity: {
          commonAreaDoorCode: '',
          gateCode: '',
          conferenceRoomCode: '',
          packageAreaCode: '',
          mailroomCode: '',
        },
        mailDelivery: {
          receivingAddress: '',
          incomingUpsFedexLocation: '',
          incomingUspsLocation: '',
          outgoingUpsFedexLocation: '',
          outgoingUspsLocation: '',
          upsSchedule: '',
          fedexSchedule: '',
          uspsSchedule: '',
        },
        guidelines: {
          rulesPdf: {
            name: '',
            url: '',
          },
          forkliftTrainingUrl: '',
        },
      },
    };
  },
  watch: {
    async facility() {
      await this.loadOpsInfo();
    },
  },
  async mounted() {
    await this.loadOpsInfo();
  },
  methods: {
    async loadOpsInfo() {
      this.loading = true;
      try {
        const response = await axios.get(
          `${ADMIN_API_BASE}/facilities/${this.facility}`,
          {
            headers: {
              Authorization: `Bearer ${this.$keycloak.token}`,
            },
          },
        );
        const { opsInfo } = response.data;
        const wifi = (opsInfo && opsInfo.wifiDetails) || {};
        const trash = (opsInfo && opsInfo.trashPickup) || {};
        const access = (opsInfo && opsInfo.accessSecurity) || {};
        const mail = (opsInfo && opsInfo.mailDelivery) || {};
        const guide = (opsInfo && opsInfo.guidelines) || {};
        const rulesPdf = guide.rulesPdf || {};
        this.form = {
          wifiDetails: {
            ssid: wifi.ssid || '',
            password: wifi.password || '',
          },
          trashPickup: {
            location: trash.location || '',
            schedule: trash.schedule || '',
          },
          accessSecurity: {
            commonAreaDoorCode: access.commonAreaDoorCode || '',
            gateCode: access.gateCode || '',
            conferenceRoomCode: access.conferenceRoomCode || '',
            packageAreaCode: access.packageAreaCode || '',
            mailroomCode: access.mailroomCode || '',
          },
          mailDelivery: {
            receivingAddress: mail.receivingAddress || '',
            incomingUpsFedexLocation: mail.incomingUpsFedexLocation || '',
            incomingUspsLocation: mail.incomingUspsLocation || '',
            outgoingUpsFedexLocation: mail.outgoingUpsFedexLocation || '',
            outgoingUspsLocation: mail.outgoingUspsLocation || '',
            upsSchedule: mail.upsSchedule || '',
            fedexSchedule: mail.fedexSchedule || '',
            uspsSchedule: mail.uspsSchedule || '',
          },
          guidelines: {
            rulesPdf: {
              name: rulesPdf.name || '',
              url: rulesPdf.url || '',
            },
            forkliftTrainingUrl: guide.forkliftTrainingUrl || '',
          },
        };
      } catch (err) {
        console.error(err);
        this.$message.error({
          message: 'Failed to load operations info',
        });
      }
      this.loading = false;
    },
    async submitForm() {
      this.loading = true;
      try {
        await axios.put(
          `${ADMIN_API_BASE}/facilities/${this.facility}/ops-info`,
          { opsInfo: this.form },
          {
            headers: {
              Authorization: `Bearer ${this.$keycloak.token}`,
            },
          },
        );
        this.$message.success({
          message: 'Operations info updated successfully!',
        });
      } catch (err) {
        console.error(err);
        const errMsg =
          (err.response && err.response.data) ||
          'Failed to update operations info';
        this.$message.error({
          message: errMsg,
        });
      }
      this.loading = false;
    },
    async handleRulesPdfUploaded(url) {
      this.form.guidelines.rulesPdf.url = url;
      if (!this.form.guidelines.rulesPdf.name) {
        this.form.guidelines.rulesPdf.name = 'Facility Rules';
      }
      this.loading = true;
      try {
        await axios.put(
          `${ADMIN_API_BASE}/facilities/${this.facility}/ops-info`,
          { opsInfo: this.form },
          {
            headers: {
              Authorization: `Bearer ${this.$keycloak.token}`,
            },
          },
        );
        this.$message.success({
          message: 'Facility Rules PDF uploaded and saved successfully!',
        });
      } catch (err) {
        console.error(err);
        const errMsg =
          (err.response && err.response.data) || 'Failed to save PDF';
        this.$message.error({
          message: errMsg,
        });
      }
      this.loading = false;
    },
    viewRulesPdf() {
      window.open(this.form.guidelines.rulesPdf.url, '_blank');
    },
    deleteRulesPdf() {
      this.$confirm(
        'Are you sure you want to delete the Facility Rules PDF?',
        'Delete Rules PDF',
        {
          confirmButtonText: 'Delete',
          cancelButtonText: 'Cancel',
          type: 'warning',
        },
      )
        .then(async () => {
          this.form.guidelines.rulesPdf.url = '';
          this.form.guidelines.rulesPdf.name = '';
          this.loading = true;
          try {
            await axios.put(
              `${ADMIN_API_BASE}/facilities/${this.facility}/ops-info`,
              { opsInfo: this.form },
              {
                headers: {
                  Authorization: `Bearer ${this.$keycloak.token}`,
                },
              },
            );
            this.$message.success({
              message: 'Facility Rules PDF deleted successfully!',
            });
          } catch (err) {
            console.error(err);
            const errMsg =
              (err.response && err.response.data) || 'Failed to delete PDF';
            this.$message.error({
              message: errMsg,
            });
          }
          this.loading = false;
        })
        .catch(() => {
          // User cancelled
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/FacilityOpsInfoForm.vue